import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/** @module util/dragdrop */
import React from "react";
import ReactDOM from "react-dom";
import { Icon, message } from "react-aiot";
import { request, i18n, rmlOpts, hooks } from ".";
import $ from "jquery";
import { isAttachmentsGalleryEdit } from "../hooks/modal";
import { isRatable, RatingPointer } from "@devowl-wp/real-utils";
/**
 * On CTRL holding add class 'aiot-helper-method-append' to document body.
 */

export function anyKeyHolding() {
  $(document).on("keydown", function (e) {
    $("body").addClass("aiot-helper-method-append");
    e.ctrlKey && $("body").addClass("aiot-helper-ctrl");
  });
  $(document).on("keyup", function () {
    return $("body").removeClass("aiot-helper-method-append aiot-helper-ctrl");
  });
}
/**
 * jQuery's draggable helper container.
 *
 * @param {object} props Properties
 * @param {int} props.count The count
 * @type React.Element
 */

var DragHelper = function DragHelper(_ref) {
  var count = _ref.count;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "aiot-helper-method-move"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "swap"
  }), " ", i18n(count > 1 ? "move" : "moveOne", {
    count: count
  }), /*#__PURE__*/React.createElement("p", null, i18n("moveTip"))), /*#__PURE__*/React.createElement("div", {
    className: "aiot-helper-method-append"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "copy"
  }), " ", i18n(count > 1 ? "append" : "appendOne", {
    count: count
  }), /*#__PURE__*/React.createElement("p", null, i18n("appendTip"))));
};
/**
 * Enables / Reinitializes the droppable nodes. If a draggable item is dropped
 * here the given posts are moved to the category. You have to provide a ReactJS
 * element to reload the tree.
 *
 * @param {React.Element} element The element
 */


export function droppable(element) {
  var dom = $(element.ref.container).find(".aiot-node.aiot-droppable[data-id!='all']"),
      attachmentsBrowser = element.attachmentsBrowser;
  dom.droppable({
    activeClass: "aiot-state-default",
    hoverClass: "aiot-state-hover",
    tolerance: "pointer",
    drop: function () {
      var _drop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event, ui) {
        var ids, toTmp, to, activeId, elements, fnFade, isCopy, store, isOne, i18nProps, i18nGet, hide, _yield$request, counts, removedFolderIds, fadeBack;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ids = [], toTmp = $(event.target).attr("data-id"), to = toTmp === "all" ? toTmp : +toTmp, activeId = element.getSelectedId(), elements = [], fnFade = function fnFade(percent) {
                  return elements.forEach(function (obj) {
                    return obj.fadeTo(250, percent);
                  });
                }, isCopy = $("body").hasClass("aiot-helper-method-append"), store = element.props.store; // Get dragged items

                iterateDraggedItem(ui.draggable, element, function (tr) {
                  ids.push(+tr.find('input[type="checkbox"]').attr("value"));
                  elements.push(tr);
                }, function (attributes, attachmentsBrowser) {
                  ids.push(attributes.id);
                  elements.push(attachmentsBrowser.$el.find('li[data-id="' + attributes.id + '"]'));
                });
                element.setState({
                  isTreeLinkDisabled: true
                }); // Disable tree

                fnFade(0.3); // Make folders updateable in grid mode

                if (attachmentsBrowser) {
                  // If the target is "Uncategorized" the current folder has to be refreshed, too
                  store.addFoldersNeedsRefresh(to);
                  to === +rmlOpts.others.rootId && store.addFoldersNeedsRefresh(activeId);
                } // Get i18n key


                isOne = ids.length === 1, i18nProps = {
                  count: ids.length,
                  category: $(event.target).find(".aiot-node-name").html()
                }, i18nGet = function i18nGet(key) {
                  return i18n((isCopy ? "append" : "move") + key + (isOne ? "One" : ""), i18nProps);
                };
                hide = message.loading(i18nGet("LoadingText"));
                _context.prev = 7;
                _context.next = 10;
                return request({
                  location: {
                    path: "/attachments/bulk/move",
                    method: "PUT"
                  },
                  request: {
                    ids: ids,
                    to: to,
                    isCopy: isCopy
                  }
                });

              case 10:
                _yield$request = _context.sent;
                counts = _yield$request.counts;
                removedFolderIds = _yield$request.removedFolderIds;
                // Remove the folders which got deleted through the move process
                removedFolderIds && removedFolderIds.length && removedFolderIds.forEach(function (id) {
                  var obj = store.getTreeItemById(+id);
                  obj && obj.visible(false);
                });
                /**
                 * Attachment items got moved.
                 *
                 * @event module:util/hooks#attachment/move/finished
                 * @param {int[]} ids The attachment ids
                 * @param {int|string} to The destination folder
                 * @param {boolean} isCopy If true the files were copied (shortcut)
                 * @this module:AppTree~AppTree
                 * @since 4.0.7
                 */

                hooks.call("attachment/move/finished", [ids, to, isCopy], element); // Show rating pointer

                isRatable(rmlOpts.slug) && new RatingPointer(rmlOpts.slug, $(event.target));
                message.success(i18nGet("Success"));
                element.fetchCounts(counts); // Deselect for the next bulk selection action

                elements.forEach(function (obj) {
                  var attachmentPreview = obj.children(".attachment-preview");
                  obj.hasClass("selected") && attachmentPreview.length && attachmentPreview.click();
                }); // Update items view

                fadeBack = isCopy || !isCopy && activeId === to || activeId === "all";
                fadeBack ? fnFade(1) : elements.forEach(function (obj) {
                  return obj.remove();
                }); // Refresh view if necessery

                if (activeId === "all" && isCopy || isCopy && activeId === to) {
                  element.handleReload();
                } // Add no media


                if (!element.attachmentsBrowser && !$(".wp-list-table tbody tr").length) {
                  $(".wp-list-table tbody").html('<tr class="no-items"><td class="colspanchange" colspan="6">' + rmlOpts.others.lang.noEntries + "</td></tr></tbody>");
                }

                _context.next = 29;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context["catch"](7);
                message.error(_context.t0.responseJSON.message);
                fnFade(1);

              case 29:
                _context.prev = 29;
                hide();
                element.setState(function () {
                  return {
                    isTreeLinkDisabled: false
                  };
                }); // Enable tree

                return _context.finish(29);

              case 33:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 25, 29, 33]]);
      }));

      function drop(_x, _x2) {
        return _drop.apply(this, arguments);
      }

      return drop;
    }()
  });
}
/*
 * Iterates through the UI and gets the collection of dragged items.
 *
 * @param {jQuery} ui The draggable ui object
 * @param {React.Element} container The AIOT container
 * @param {function} [listMode] Function to iterate over list mode items (<tr> object)
 * @param {function} [gridMode] Function to iterate over grid mode items (attributes, attachmentsBrowser)
 * @returns {int} The count of selected items
 */

function iterateDraggedItem(ui, _ref2, listMode, gridMode) {
  var attachmentsBrowser = _ref2.attachmentsBrowser;

  if (attachmentsBrowser) {
    // Grid mode
    var selection = attachmentsBrowser.options.selection.models;

    if (selection.length) {
      selection.forEach(function (model) {
        gridMode && gridMode(model.attributes, attachmentsBrowser);
      });
      return selection.length;
    } else {
      var id = ui.data("id"),
          models = attachmentsBrowser.collection.models;
      gridMode && gridMode(models.filter(function (model) {
        return model.id === id;
      })[0], attachmentsBrowser);
      return 1;
    }
  } else {
    // List mode
    var trs = $("#the-list > tr > .check-column > input:checked");

    if (trs.length) {
      trs.each(function () {
        listMode && listMode($(this).parents("tr"));
      });
    } else {
      listMode && listMode(ui);
    }

    return trs.length || 1;
  }
}
/**
 * Make the list table draggable if sort mode is not active.
 *
 * @param {React.Element} element The element
 * @param {boolean} [destroy=false] If true the draggable gets destroyed
 */


export function draggable(element, destroy) {
  // Get selector
  var attachmentsBrowser = element.attachmentsBrowser,
      _element$state = element.state,
      isMoveable = _element$state.isMoveable,
      isWPAttachmentsSortMode = _element$state.isWPAttachmentsSortMode,
      attachments = attachmentsBrowser && attachmentsBrowser.attachments,
      selector = attachmentsBrowser ? attachmentsBrowser.$el.find("ul.attachments > li") : $("#wpbody-content .wp-list-table tbody tr:not(.no-items)"),
      isGalleryEdit = isAttachmentsGalleryEdit(attachments); // Make draggable

  if (destroy || !isMoveable || isWPAttachmentsSortMode || isGalleryEdit || // Avoid drag & drop on mobile
  document.documentElement.clientWidth <= 900) {
    try {
      selector.draggable("destroy");
    } catch (e) {// Silence is golden.
    } // In gallery edit mode enable the built-in sortable


    if (isGalleryEdit) {
      attachments.collection.comparator = undefined;
      attachments.initSortable();
    }
  } else {
    selector.draggable({
      revert: "invalid",
      revertDuration: 0,
      appendTo: "body",
      cursorAt: {
        top: 0,
        left: 0
      },
      distance: 10,
      refreshPositions: true,
      helper: function helper(event) {
        var helper = $('<div class="aiot-helper"></div>').appendTo($("body")),
            count = iterateDraggedItem($(event.currentTarget), element);
        ReactDOM.render( /*#__PURE__*/React.createElement(DragHelper, {
          count: count
        }), helper.get(0));
        return helper;
      },
      start: function start() {
        $("body").addClass("aiot-currently-dragging"); // FIX https://bugs.jqueryui.com/ticket/4261

        $(document.activeElement).blur();
      },
      stop: function stop() {
        return setTimeout(function () {
          $("body").removeClass("aiot-currently-dragging");
        }, 50);
      }
    });
  }
}